export const CONSENT_COOKIE_NAME = "osc_cookie_consent";
export const CONSENT_VERSION = 1;
const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export type CookieConsent = {
  version: number;
  necessary: true;
  analytics: boolean;
};

export const necessaryOnlyConsent = (): CookieConsent => ({
  version: CONSENT_VERSION,
  necessary: true,
  analytics: false,
});

export const acceptAllConsent = (): CookieConsent => ({
  version: CONSENT_VERSION,
  necessary: true,
  analytics: true,
});

function isValidConsent(value: unknown): value is CookieConsent {
  if (!value || typeof value !== "object") {
    return false;
  }
  const record = value as Partial<CookieConsent>;
  return (
    record.version === CONSENT_VERSION &&
    record.necessary === true &&
    typeof record.analytics === "boolean"
  );
}

export function readConsent(): CookieConsent | null {
  if (typeof document === "undefined") {
    return null;
  }
  const prefix = `${CONSENT_COOKIE_NAME}=`;
  const match = document.cookie
    .split("; ")
    .find((part) => part.startsWith(prefix));
  if (!match) {
    return null;
  }
  try {
    const parsed: unknown = JSON.parse(decodeURIComponent(match.slice(prefix.length)));
    return isValidConsent(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writeConsent(consent: CookieConsent): void {
  if (typeof document === "undefined") {
    return;
  }
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = [
    `${CONSENT_COOKIE_NAME}=${encodeURIComponent(JSON.stringify(consent))}`,
    "Path=/",
    `Max-Age=${CONSENT_MAX_AGE_SECONDS}`,
    "SameSite=Lax",
    secure,
  ]
    .filter(Boolean)
    .join("; ");
}

export function hasAnalyticsConsent(consent?: CookieConsent | null): boolean {
  return (consent ?? readConsent())?.analytics === true;
}
